export default __webpack_public_path__ + "static/media/winners-blue.b87ae940.svg";